import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';
import './combine-bins-modal';

class CombineBinsButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
      binsHref: { type: String, attribute: false },
      startAggregateBinAction: { type: Object, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      bn-icon {
        margin-right: .25em;
      }
    `];
  }

  render() {
    return html`
      <lit-entity .href="${this.binsHref}" @update="${this._onUpdateBins}"></lit-entity>
      ${renderIf(this.startAggregateBinAction, () => html`
        <button class="button button--contained" @click="${this._onClick}">
          <bn-icon name="fas fa-ball-pile"></bn-icon> Create Tandem
        </button>

        <combine-bins-modal
          .href="${this.href}"
          ?hide="${!this.showModal}"
          @close="${() => this.showModal = false}"
        ></combine-bins-modal>
      `)}
    `;
  }

  _onUpdateBins(e) {
    const { entity } = e.detail;
    this.startAggregateBinAction = entity && entity.getAction('start-aggregate-bin');
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }

  async _entityChanged(entity) {
    super._entityChanged(entity);
    this.binsHref = this.getHref('https://api.binsentry.com/rel/v2/bins');
  }
}

window.customElements.define('combine-bins-button', CombineBinsButton);
